import {NgModule} from "@angular/core";
import {ConfirmPolicyDialogComponent} from './confirm-policy-dialog/confirm-policy-dialog.component';

@NgModule({
  declarations: [
    ConfirmPolicyDialogComponent
  ],
  exports: [
    ConfirmPolicyDialogComponent
  ]
})
export class HelpersModule {

}
